import { useState } from "react";
import { useSetAtom, useAtomValue, useAtom } from "jotai";
import { Image } from "@react-three/drei";
import { 
  joinTeamAtom, 
  guestBeingEdittedAtom, 
  languageModalOpenAtom,
  audioVolumeAtom,
  settingsOpenAtom,
  showGameRulebookAtom
} from "../GlobalState.jsx";
import useSoundEffectsPlayer from "../soundPlayers/useSoundEffectsPlayer.jsx";

export default function LanguageButtonGame(props) {
  const [hover, setHover] = useState(false)
  const setJoinTeam = useSetAtom(joinTeamAtom)
  const setGuestBeingEditted = useSetAtom(guestBeingEdittedAtom)
  const [languageModalOpen, setLanguageModalOpen] = useAtom(languageModalOpenAtom)
  const setSettingsOpen = useSetAtom(settingsOpenAtom)
  const setShowRulebook = useSetAtom(showGameRulebookAtom)
  const { playSoundEffect } = useSoundEffectsPlayer()
  const audioVolume = useAtomValue(audioVolumeAtom)

  function handlePointerEnter(e) {
    e.stopPropagation()
    setHover(true)
    document.body.style.cursor = 'pointer'
  }
  function handlePointerLeave(e) {
    e.stopPropagation()
    setHover(false)
    document.body.style.cursor = 'default'
  }
  function handlePointerDown(e) {
    e.stopPropagation()
    if (languageModalOpen) {
      setLanguageModalOpen(false)
    } else {
      setLanguageModalOpen(true)
      setGuestBeingEditted(null)
      setSettingsOpen(false)
      setShowRulebook(false)
    }
    playSoundEffect('/sounds/effects/button-click.mp3', audioVolume)
  }
  return <group {...props}>
    <mesh 
      name='wrapper' 
      onPointerEnter={e => handlePointerEnter(e)}
      onPointerLeave={e => handlePointerLeave(e)}
      onPointerDown={e => handlePointerDown(e)}
    >
      <boxGeometry args={[1, 0.1, 1]}/>
      <meshStandardMaterial transparent opacity={0}/>
    </mesh>
    <group scale={[0.6, 1, 1]} >
      <Image
        url={ '/images/translate-icon-easy-orange.png' }
        scale={1.7}
        position={[0, 1, 0.7]}
        rotation={[0, 0, 0]}
        transparent
      />
    </group>
  </group>
}
